import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Link, Tooltip, Typography } from "@mui/material";
import React, { Suspense, useState } from "react";
import useDetail from "../../../../hooks/useDetail.ts";
import { isEvyveska } from "../../../../utills/iframeVariants.ts";

interface TextWithLinksProps {
	text: string;
}

const TextWithLinks: React.FC<TextWithLinksProps> = ({ text }) => {

  if(isEvyveska()) {
    return text;
  }

	// Regular expression to match URLs
	const urlPattern = /https?:\/\/\S+/g;

	// Split the text into segments: part of the text that are URLs and other text
	const segments = text.split(urlPattern);

	// Find the URLs in the text
	const urls = text.match(urlPattern) || [];

	// Create a new array where URLs are replaced by <Link> components
	const content = segments.map((segment, index) => {
		if (index < urls.length) {
			// Add the URL wrapped in a MUI <Link> component
			return (
				<React.Fragment key={segment}>
					{segment}
					<Link href={urls[index]} target="_blank" rel="noopener noreferrer">
						{urls[index]}
					</Link>
				</React.Fragment>
			);
		}
		return <span key={segment}>{segment}</span>;
	});

	return <Typography sx={{ whiteSpace: "pre-wrap" }}>{content}</Typography>;
};

const Description: React.FC<{ id: number }> = ({ id }) => {
	const [expandedDescription, setExpandedDescription] = useState<boolean>(true);
	const detail = useDetail(id);

	const description = detail.data.description;

	if (!description) {
		return null;
	}

	return (
		<Accordion expanded={expandedDescription}>
			<Tooltip followCursor={true} placement="right" title={expandedDescription ? "Skrýt popis" : "Zobrazit popis"}>
				<AccordionSummary
					onClick={() => setExpandedDescription(!expandedDescription)}
					sx={{ backgroundColor: "grey.200" }}
					expandIcon={<ExpandMore fontSize="medium" color="secondary" />}
				>
					<Typography fontWeight="bolder" sx={{ color: "info.main" }} variant="subtitle1" component="div">
						Popis
					</Typography>
				</AccordionSummary>
			</Tooltip>
			<AccordionDetails>
				<TextWithLinks text={description} />
			</AccordionDetails>
		</Accordion>
	);
};

const AdDescription: React.FC<{ id: number }> = ({ id }) => {
	return (
		<Suspense>
			<Description id={id} />
		</Suspense>
	);
};

export default AdDescription;
